import React from "react";
import {AppBar, createStyles, Toolbar, Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
// import {useTranslation} from "react-i18next";

const useStyles = makeStyles(() =>
    createStyles({
        logo: {
            height: 40,
        },
      title: {
          flexGrow:1
      },
      btn: {
          margin: 5
      }
    }),
);
const Navbar: React.FC<{}> = () =>{
  // const { t } = useTranslation();
  const classes = useStyles();
    return (
      <>
        <AppBar
          position="fixed">
          <Toolbar>
            <img className={classes.logo}
                 src={require(`../assets/WhiteFaceTagline.png`)}
                 alt="icon"
                 data-src={require("../assets/WhiteFaceTagline.png")}
                 loading={'lazy'}
            />
            <Typography
              variant="h6"
              className={classes.title}/>
            {/*<Box>*/}
            {/*  <Button*/}
            {/*    variant={"outlined"}*/}
            {/*    color={"secondary"}*/}
            {/*    className={classes.btn}>*/}
            {/*    {t('Sing In')}*/}
            {/*  </Button>*/}
            {/*  <Button*/}
            {/*    variant={"contained"}*/}
            {/*    color={"secondary"}*/}
            {/*    className={classes.btn}>*/}
            {/*    {t('Sing Up')}*/}
            {/*  </Button>*/}
            {/*</Box>*/}
          </Toolbar>
        </AppBar>
      </>
    )
}
export default Navbar
